// extracted by mini-css-extract-plugin
export default {"icon":"BurgerIcon_icon__dmNIj","icon__large":"BurgerIcon_icon__large__AoNSP","icon__fill":"BurgerIcon_icon__fill__OG5gC"};